export default __webpack_public_path__ + "static/media/Prospectus.54d31e91.pdf";